module.exports = __webpack_public_path__ + "static/iphone-45eb0f3f0f1ce11cc8ef9e5dce30501e.png";